module.exports = __webpack_public_path__ + "img/16_4.916e489f.png";